import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSearch = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1908_701)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_1908_701",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 15,
			height: 15,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M15 0H0V15H15V0Z",
				fill: "white"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_1908_701)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M14.5 14.5L10.25 10.25M11.5 6.5C11.5 9.26142 9.26142 11.5 6.5 11.5C3.73858 11.5 1.5 9.26142 1.5 6.5C1.5 3.73858 3.73858 1.5 6.5 1.5C9.26142 1.5 11.5 3.73858 11.5 6.5Z",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1908_701",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 15,
			height: 15,
			fill: "white"
		})
	}) })]
});
export default SvgIconSearch;
